import React from 'react';
import cx from 'classnames';

import { mapValidationOutputToJSX } from './mapValidationOutputToJSX';

interface InputValidationProps {
    addClasses?: string;
    showOnlyFirstError?: boolean;
    validationOutputs: ValidationOutput[];
}

export const InputValidation = ({
    addClasses,
    showOnlyFirstError,
    validationOutputs,
}: InputValidationProps): JSX.Element | null => {
    if (showOnlyFirstError) {
        return validationOutputs.length > 0 ? (
            <span className={cx(addClasses)}>
                {mapValidationOutputToJSX(validationOutputs[0])}
            </span>
        ) : null;
    }

    return (
        <span className={cx(addClasses)}>
            {validationOutputs.map(mapValidationOutputToJSX)}
        </span>
    );
};
